import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/styled-system'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'

import { getName } from '@mangovoice/core'

import { sharedComponentColorKeys } from './_colors'

const Colors = sharedComponentColorKeys.MenuItem

export const MenuItemStyleValues = {
  defaultOuterContainerWidth: 'full',
}

const MenuItemParts = [
  'outerContainer',
  'itemContainer',
  'textContainer',
  'primaryText',
  'destructiveText',
  'secondaryText',
] as const

const helpers = createMultiStyleConfigHelpers(MenuItemParts)
export const MenuItemStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    outerContainer: {
      borderRadius: '0.5rem',
      _hover: {
        backgroundColor: Colors.Container.Hover.BackgroundColor,
      },
      _active: {
        backgroundColor: Colors.Container.Active.BackgroundColor,
      },
      cursor: 'pointer',
    },
    itemContainer: {
      justifyContent: 'space-between',
      alignItems: 'center',
      gap: '0.5rem',
      paddingY: '0.5rem',
      paddingX: '0.75rem',
      width: 'full',
    },
    textContainer: {
      flexDirection: 'column',
      flexGrow: 1,
    },
    primaryText: {
      textStyle: 'Body1',
      lineHeight: '1.5rem',
      userSelect: 'none',
    },
    destructiveText: {
      textStyle: 'Body1',
      lineHeight: '1.5rem',
      color: Colors.DestructiveText.FontColor,
      userSelect: 'none',
    },
    secondaryText: {
      textStyle: 'Body2',
      color: Colors.SecondaryText.FontColor,
      userSelect: 'none',
    },
  },
})

export const useMenuItemStyles = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof MenuItemParts>(
    getName({ MenuItemStyle }),
    props,
  )
}
